// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__1EbRM","success":"FinishedQuiz_success__1z6wD","error":"FinishedQuiz_error__20_Y4"};